import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  iaIconArrowDownLineBlack,
  iaIconCheckmark,
  iaIconCircleCheckFilledPart,
  iaIconCircleXmark,
  iaIconFileLines,
  iaIconInformationWhite,
  iaIconMemo,
} from '@bcef/ia-icons';
import { IconsRegistry } from '@bcef/ia-ng-icons';
import { ContextService, getClassNames } from '@bcef/ia-shared';
import { DataLayer } from '@difa/ia-data-layer';
import { TranslateService } from '@ngx-translate/core';
import classNames from 'classnames';

@Component({
  selector: 'ia-succession-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [RouterOutlet],
  standalone: true,
})
export class AppComponent implements OnInit {
  protected typologies = '';

  private readonly translate = inject(TranslateService);

  private readonly iconsRegistry = inject(IconsRegistry);

  private readonly contextService = inject(ContextService);

  private readonly _datalayer = inject(DataLayer);

  public ngOnInit(): void {
    this.translate.use(this.contextService.language);
    this.typologies = classNames(getClassNames(this.contextService.typology));
    this.iconsRegistry.registerIcons([
      iaIconFileLines,
      iaIconInformationWhite,
      iaIconCheckmark,
      iaIconCircleXmark,
      iaIconCircleCheckFilledPart,
      iaIconArrowDownLineBlack,
      iaIconMemo,
    ]);
  }
}
